module.exports = __webpack_public_path__ + "img/contact.a10fac02.jpg";